import React, { useState } from 'react'
import BeginChat from './BeginChat'
import { Grid } from '@mui/material'

export default function JobForm (props: any) {
  const { loading, showStart, sendChat, showChat, setShowChat, setJob, setExperience, defaultJob, defaultExperience, showInputError, name, setName, loggingMetrics, setLoggingMetrics } = props
  const [nameError, setNameError] = useState(false)

  const handleStartButtonClick = async () => {
    setLoggingMetrics({
      ...loggingMetrics,
      'startedInterviewCnt':loggingMetrics['startedInterviewCnt']+1
    })
    if (name.trim() === '') {
      setNameError(true)
    } else {
      await sendChat('')
      setShowChat(true)
    }
  }
  const handleJobInput = (event: any) => {
    setJob(event.target.value)
  }
  const handleExperienceInput = (event: any) => {
    setExperience(event.target.value)
  }
  const handleNameInput = (event: any) => {
    setName(event.target.value)
  }

  return (
    <>
      {!showChat && showStart && (
        <Grid item xs={12}>
          <div style={{ marginBottom: '12px' }}>
            <label>
              Full Name:
              <div>
                <input
                  onChange={handleNameInput}
                  defaultValue={'John Doe'}
                  maxLength={20}
                  style={{ width: '100%' }}
                />
              </div>
            </label>
          </div>
          <div>
            <label>
              Job Description:
              <div>
                <textarea
                  rows={4}
                  onChange={handleJobInput}
                  defaultValue={defaultJob}
                  style={{ width: '100%' }}
                />
              </div>
            </label>
          </div>
          <div>
            <label>
              Candidate Experience:
              <div>
                <textarea
                  rows={4}
                  onChange={handleExperienceInput}
                  defaultValue={defaultExperience}
                  style={{ width: '100%' }}
                />
              </div>
            </label>
            {showStart && nameError && (
              <Grid>
                <p style={{ color: 'red' }}>Please enter your name.</p>
              </Grid>
            )}
          </div>

          <BeginChat loading={loading} onClick={handleStartButtonClick} loggingMetrics={loggingMetrics} setLoggingMetrics={setLoggingMetrics} />
        </Grid>
      )}
    </>
  )
}
